module.exports = __webpack_public_path__ + "img/gallery-image-22.77e0b76b.jpg";